(function () {
  'use strict';
  if (window.__nbfClickFlareGate) return;
  window.__nbfClickFlareGate = { loaded: false, reloading: false };
  var state = window.__nbfClickFlareGate;
  function allowed() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return !!api && api.analyticsProcessingAllowed() === true &&
        api.marketingAllowed() === true && api.saleOfDataAllowed() === true;
    } catch (error) { return false; }
  }
  function evaluate() {
    if (!allowed()) {
      if (state.loaded && !state.reloading) {
        state.reloading = true;
        // A script element removal cannot stop an already initialized vendor.
        // Reload into the denied state instead; vendor teardown still needs review.
        window.location.reload();
      }
      return;
    }
    if (state.loaded) return;
    var script = document.createElement('script');
    script.id = 'nbf-clickflare-shopify';
    script.async = true;
    script.defer = true;
    script.src = 'https://globalvisitlog.com/cf/scripts/shopify';
    state.loaded = true;
    document.body.appendChild(script);
  }
  function initialize() {
    document.addEventListener('visitorConsentCollected', evaluate);
    if (window.Shopify && window.Shopify.customerPrivacy) { evaluate(); return; }
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) evaluate();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
